<template>
    <div class="nav-user-tab-item pt-3 pl-0 pr-0 mr-0 w-100" style="max-width: 100%;">
        <v-tabs
            v-model="tab"
            height="30"
        >
            <v-tabs-slider color="primary"></v-tabs-slider>

            <v-tab href="#tab-me" class="nav-tab" style="padding: 0;">
                <div class="v-flex" v-if="tab === 'tab-me'">
                    <v-tooltip bottom >
                        <template v-slot:activator="{ on, attrs }">
                            <a
                                @click = "onStoreMyData"
                                v-bind = "attrs"
                                v-on   = "on"
                            >
                                <v-icon size="20" color="primary"  class="toolbar-button">mdi-content-save</v-icon>
                            </a>
                        </template>
                        <div class="pt-1">Meine Daten speichern</div>
                    </v-tooltip>
                    <span style="margin-top: 6px">Benutzer</span>
                </div>
                <span v-if="tab !== 'tab-me'">Benutzer</span>
            </v-tab>

            <v-tab href="#tab-display" class="nav-tab">
                <span>Dialog</span>
            </v-tab>

            <v-tab href="#tab-images" class="nav-tab">
                <span>Bildarchiv</span>
            </v-tab>

            <v-tab href="#tab-access"  class="nav-tab">
                <span>Rechte</span>
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" >
            <v-tab-item value="tab-me" style="padding: 10px">
                <nav-user-data ref="userdata" />
            </v-tab-item>

            <v-tab-item value="tab-display" style="padding: 10px">
                <v-switch
                    v-model="preferences['permanentMenu']"
                    :label="$t('nav.user.permanentmenu')"
                    :persistent-hint="true"
                    :hint="$t('nav.user.hints.permanentmenu')"
                    @change="store"
                />

                <v-switch
                    v-model="preferences['dmsdisplaymode']"
                    :label="$t('nav.user.dmsdisplaymode')"
                    :persistent-hint="true"
                    :hint="$t('nav.user.hints.dmsdisplaymode')"
                    @change="store"
                />
                <v-switch
                    v-model="preferences['noticedisplaymode']"
                    :label="$t('nav.user.noticedisplaymode')"
                    :persistent-hint="true"
                    :hint="$t('nav.user.hints.noticedisplaymode')"
                    @change="store"
                />
                <v-switch
                    v-model="preferences['memorygadget']"
                    :label="$t('nav.user.memorygadget')"
                    :persistent-hint="true"
                    :hint="$t('nav.user.hints.memorygadget')"
                    @change="store"
                />
                <v-switch
                    v-model="preferences['lgsstate']"
                    :label="$t('nav.user.lgsstate')"
                    :persistent-hint="true"
                    :hint="$t('nav.user.hints.lgsstate')"
                    @change="store"
                />
            </v-tab-item>

            <v-tab-item value="tab-images" style="padding: 10px">
                <v-switch
                    v-model="preferences['smallimages']"
                    :label="$t('nav.user.smallimages')"
                    :persistent-hint="true"
                    :hint="$t('nav.user.hints.smallimages')"
                    @change="store"
                />
                <!--
                <v-switch
                    v-model="preferences['useImageCache']"
                    :label="$t('nav.user.useimagecache')"
                    :persistent-hint="true"
                    :hint="$t('nav.user.hints.useimagecache')"
                    @change="store"
                />
                -->
            </v-tab-item>

            <v-tab-item value="tab-access" style="padding: 10px">
                <div >
                    <v-switch
                        v-model="preferences['dataadmin']"
                        :label="$t('nav.user.dataadmin')"
                        :persistent-hint="true"
                        :hint="$t('nav.user.hints.dataadmin')"
                        class="mt-0"
                        @change="store"
                    />
                    <v-switch
                        v-if="privileged"
                        v-model="preferences['editTerminated']"
                        :label="$t('nav.user.editterminated')"
                        :persistent-hint="true"
                        :hint="$t('nav.user.hints.editterminated')"
                        @change="store"
                    />
                    <v-switch
                        v-if="admin"
                        v-model="preferences['restoredata']"
                        :label="$t('nav.user.restoreincidents')"
                        :persistent-hint="true"
                        :hint="$t('nav.user.hints.restoreincidents')"
                        @change="store"
                    />
                    <v-switch
                        v-if="admin"
                        v-model="preferences['restoreNotices']"
                        :label="$t('nav.user.restorenotices')"
                        :persistent-hint="true"
                        :hint="$t('nav.user.hints.restorenotices')"
                        @change="onRestoreJournal"
                    />
                </div>
            </v-tab-item>

        </v-tabs-items>
    </div>




</template>

<script>
import security from "@/main";
import Inc from "@/modules/inc/service/Inc";
import Core from "@/modules/core/service/Core";
import NavUserData from "@/modules/msd/user/components/nav/NavUserData";

export default {
    name: "NavUserPreferences",

    components: {
        NavUserData
    },

    computed: {
        liftmanager () {
            return Core.role.liftmanager();
        },

        admin () {
            return Core.role.admin();
        },

        privileged () {
            return Core.role.privileged();
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        themes () {
            return this.$store.getters.themes;
        },

        profile () {
            return security.profile();
        },
    },

    data: () => ({
        tab: null,
    }),

    watch: {
        tab () {
        }
    },

    methods: {
        onRestoreJournal () {
            this.$bus.$emit(Inc.events.journal);
            this.store();
        },

        store () {
            Core.preferences.store(this, this.preferences);
        },

        onStoreMyData () {
            this.$refs.userdata.onSave();
        }
    },
}
</script>

<style scoped>

.nav-title {
    font-size: 15px; font-weight: 400;
}

.nav-tab {
   width: 110px;
}

.nav-tab span {
    font-size: 15px; font-weight: normal;
}


</style>